import deviceService from '../service/device'

const state =
{
    deviceLoading: false,
    devices: [],
    deviceBattery: {}
};

const actions = {
    getAllDevices({ commit }) {
        commit('setLoading', true)
        return deviceService.getAllDevices().then(devices => {
            commit('setdevices', devices)
        }).finally(() =>
            commit('setLoading', false)
        )
    },
    getDevices({ commit }, value) {
        commit('setLoading', true)
        return deviceService.getDevices(value).then(devices => {
            commit('setdevices', devices)
        }).finally(() =>
            commit('setLoading', false)
        )
    },
    getRoutingLookup({ commit }, value) {
        commit('setLoading', true)
        return deviceService.getRoutingLookup(value).then(data => {
            commit('setdeviceBattery', data)
            return data
        })
    },
};
const mutations = {

    setLoading(state, bool) {
        state.deviceLoading = bool
    },
    setdevices(state, devices) {
        state.devices = devices
        state.deviceLoading = false
    },
    setdeviceBattery(state, data) {
        if (data.data.batteryLevel && data.data.batteryLevel.length > 0) {
            state.deviceBattery = data.data.batteryLevel[0]
        }
    },

};
export default {
    namespaced: true,
    state,
    actions,
    mutations
};
